import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";

import { useHistory } from "react-router-dom";

import {
  getTemplatesApiHandler,
  createCustTemplateApiHandler,
  deleteGroupingTemplateApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

import { Button } from "../../elements/Button";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchPri.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/whitePlus.svg";
import { ReactComponent as MyFinIcon } from "../../assets/icons/myFinCardIcon.svg";
import { ReactComponent as MenuDotIcon } from "../../assets/icons/menuDotBlack.svg";
import { ReactComponent as RemoveIcon } from "../../assets/icons/Close-green.svg";
import user from "../../assets/imgs/user3.jpg";
import libcss from "../../css/library.module.css";

import CustomTemplateModal from "../../components/templateLibrary/CustomTemplateModal";

const StandaloneLibrary = () => {
  let history = useHistory();
  const [defaultLibraryList, setDefaultLibraryList] = useState([]);
  const [customLibraryList, setCustomLibraryList] = useState([]);
  const [createCustomTemplateModal, setCreateCustomTemplateModal] =
    useState(false);

  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    getTemplates();
  }, []);

  const getTemplates = () => {
    getTemplatesApiHandler({ sortField: "createdAt", sortOrder: "desc" })
      .then((response) => {
        if (response?.data?.success === true) {
          var templatesResp = response?.data?.groupingTemplateArray;
          templatesResp.forEach((obj) => {
            if (obj.templateType === "default") {
              setDefaultLibraryList((prev) => [...prev, obj]);
            }
            if (obj.templateType === "custom") {
              setCustomLibraryList((prev) => [...prev, obj]);
            }
          });
          setLoader(false);
        }
        setLoader(false);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to create custom template",
          "error"
        );
        setLoader(false);
      });
  };

  const createCustTemplate = (payload) => {
    createCustTemplateApiHandler(payload)
      .then((response) => {
        console.log("response", response);
        if (response?.data?.success === true) {
          swal("Custom template created successfully", "", "success");
          setDefaultLibraryList([]);
          setCustomLibraryList([]);
          getTemplates();
          setCreateCustomTemplateModal(false);
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to create custom template",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to create custom template",
          "error"
        );
      });
  };

  // Close on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };

    if (openMenuId) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openMenuId]);

  const deleteGroupingTemplate = (tempId) => {
    swal({
      title: "Confirm deletion of custom template",
      text: "Once deleted, you will not be able to recover this!",
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Delete",
          value: true,
          visible: true,
          className: "swal-delete-btn",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoader(true);
        deleteGroupingTemplateApiHandler({ groupingTemplateID: tempId })
          .then((response) => {
            if (response?.data?.success === true) {
              swal("Success", "Template deleted successfully", "success");
              const templatesResp = Array.isArray(response?.data?.groupingTemplateArray)
                ? response.data.groupingTemplateArray
                : null;

              if (templatesResp) {
                const nextDefault = [];
                const nextCustom = [];
                templatesResp.forEach((obj) => {
                  if (obj.templateType === "default") nextDefault.push(obj);
                  if (obj.templateType === "custom") nextCustom.push(obj);
                });
                setDefaultLibraryList(nextDefault);
                setCustomLibraryList(nextCustom);
              } else {
                setDefaultLibraryList((prev) =>
                  prev.filter((obj) => obj._id !== tempId)
                );
                setCustomLibraryList((prev) =>
                  prev.filter((obj) => obj._id !== tempId)
                );
              }
            }
            setLoader(false);
          })
          .catch((error) => {
            console.error(
              "Delete grouping template failed",
              error?.response?.data?.error || error
            );
            setLoader(false);
          });
      }
    });
  };
 
const getRelativeTime = (date) => {
  if (!date) return "";
  
  const days = Math.floor((new Date() - new Date(date)) / (1000 * 60 * 60 * 24));
  
  if (days === 0) return "Last edited today";
  if (days === 1) return "Last edited 1 day ago";
  if (days < 30) return `Last edited ${days} days ago`;
  if (days < 365) return `Last edited ${Math.floor(days / 30)} months ago`;
  return `Last edited ${Math.floor(days / 365)} years ago`;
};

const filteredDefaultLibraryList = defaultLibraryList.filter((obj) => {
  const searchValue = searchText.toLowerCase();

  return (
    obj.name?.toLowerCase().includes(searchValue) ||
    obj.createdByName?.toLowerCase().includes(searchValue)
  );
});

const filteredCustomLibraryList = customLibraryList.filter((obj) => {
  const searchValue = searchText.toLowerCase();

  return (
    obj.name?.toLowerCase().includes(searchValue) ||
    obj.createdByName?.toLowerCase().includes(searchValue)
  );
});

  return (
    <>
      <div>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={commoncss.w100}
            style={{ maxHeight: "100vh", overflowY: "hidden" }}
          >
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={commoncss.w100}
              style={{ maxHeight: "95vh", overflowY: "hidden" }}
            >
              <header className={`connections-header ${commoncss.greyBg}`}>
                <span className="header-title">Template Library</span>
                <div className="button-group"></div>
                <div className="header-actions">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "20px",
                    gap: "10px",
                  }}
                >
                {!showSearch ? (
                  <div
                    onClick={() => setShowSearch(true)}
                    style={{ cursor: "pointer", display: "flex" }}
                  >
                    <SearchIcon width={19} height={19} />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #c2e6d1",
                      background: "#f4faf5",
                      borderRadius: "8px",
                      padding: "0 0 0 10px",
                      minWidth: "250px",
                      height: "35px",
                      width: "150px"
                    }}
                  >
                    {/* Left Search Icon */}
                    <SearchIcon width={16} height={16} />

                    {/* Input */}
                    <input
                      type="text"
                      placeholder="Type something to Search..."
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      style={{
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        marginLeft: "3px",
                        flex: 1,
                        fontSize: "14px",
                        color: "#33584e",
                      }}
                    />

                    <span
                      onClick={() => {
                        setShowSearch(false);
                        setSearchText("");
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <RemoveIcon style={{ width: "35px", height: "35px" }}/>
                    </span>
                  </div>
                )}
              </div>

                  <div style={{ marginRight: "15px" }}>
                    <FilterIcon />
                  </div>
                  <Button
                    icon={<PlusIcon width={18} height={18} />}
                    btnColor={buttoncss.primary}
                    label={"Custom Template"}
                    onClick={() => setCreateCustomTemplateModal(true)}
                  />
                </div>
              </header>
            </motion.div>

            <div className={`${libcss.libHomeBody}`}>
              <div className="mt-3">
                <span
                  className={`${commoncss.labelBlack} ${commoncss.fs19} ml-4`}
                >
                  MyFinalyst Templates (Default)
                </span>
                <motion.div
                  initial={{ y: 100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 0, opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  className="modulecards-grid"
                >
                  {filteredDefaultLibraryList.map((obj, idx) => (
                    <div
                      className={`${libcss.libCard} clickable`}
                      style={{
                        "min-height": "180px",
                        position: "relative",
                      }}
                      onClick={() =>
                        history.push(
                          `/myfinV2/library/viewedit-library/${obj._id}`
                        )
                      }
                    >
                      <span>
                        <span className={commoncss.dFlexJustifysb}>
                          <span className={commoncss.dFlex}>
                            <MyFinIcon />
                            <span className="ml-2 modulecard-title truncate-2">
                              {obj.name}
                            </span>
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenMenuId(obj._id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <MenuDotIcon width={20} height={20} />
                          </span>
                        </span>
                        <span className={`${libcss.desc1} truncate-4 mt-3`}>
                          {obj.description}
                        </span>
                      </span>
                      {openMenuId === obj._id && (
                        <div
                          ref={menuRef}
                          className={libcss.floatingMenu}
                          onMouseLeave={() => {
                            setTimeout(() => setOpenMenuId(null), 120);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            onClick={() => {
                              history.push(
                                `/myfinV2/library/viewedit-library/${obj._id}`
                              );
                            }}
                          >
                            View
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </motion.div>
              </div>
              <div className="mt-3">
                <span
                  className={`${commoncss.labelBlack} ${commoncss.fs19} ml-4`}
                >
                  Custom Templates
                </span>
                {loader ? (
                  <div className={commoncss.fsTableLoaderDiv}>
                    <Spinner animation="grow" size="sm" />
                    <Spinner animation="grow" style={{ margin: "1rem" }} />
                    <Spinner animation="grow" size="sm" />
                  </div>
                ) : (
                  <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 0, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="modulecards-grid"
                  >
                    {filteredCustomLibraryList.map((obj) => (
                      <div
                        key={obj._id}
                        className={`${libcss.libCard} clickable`}
                        style={{ minHeight: "180px", position: "relative" }}
                        onClick={() =>
                          history.push(
                            `/myfinV2/library/viewedit-library/${obj._id}`
                          )
                        }
                      >
                        <span>
                          <span className={commoncss.dFlexJustifysb}>
                            <span className={commoncss.dFlex}>
                              {/* <MyFinIcon /> */}
                              <span className="modulecard-title truncate-2">
                                {obj.name}
                              </span>
                            </span>

                            {/* Menu icon */}
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenMenuId(obj._id);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <MenuDotIcon width={20} height={20}/>
                            </span>
                          </span>

                           <div style={{ display: "flex", alignItems: "center", marginTop: "8px" , cursor: "default"}}>
                             <img
                              src={obj.createdByAvatar || user}
                              alt="creator"
                              style={{
                                width: "30px",
                                height: "28px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                marginRight: "8px",
                              }}
                            />
                            <span style={{ fontSize: "14px", color: "#33584e", fontWeight: 400}}>
                              Created by {obj.createdByName || "User"}
                            </span>
                          </div>

                          <span className={`${libcss.desc1} truncate-4 mt-3`}>
                            {obj.description}
                          </span>
                          <span style={{display: "flex", flexDirection: "column", height: "100%"}}>
                            <div style={{ fontSize: "12px", fontWeight: 400 , color: "#809790", marginTop: "30px" }}>
                            {getRelativeTime(obj.updatedAt)}
                            </div>
                          </span>
                          
                        </span>

                        {/* Floating Menu */}
                        {openMenuId === obj._id && (
                          <div
                            ref={menuRef}
                            className={libcss.floatingMenu}
                            onMouseLeave={() => {
                              setTimeout(() => setOpenMenuId(null), 120);
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div style={{ paddingBottom: 0 }}
                              onClick={() => {
                                console.log("View FS links", obj._id);
                              }}
                            >
                              <span style={{ display: "block", borderBottom: "1px solid #eaeeed", paddingBottom: "8px" }}>
                                View FS links
                              </span>
                            </div>
                            <div style={{ paddingBottom: 0 }}
                              onClick={() => {
                                console.log("Rename", obj._id);
                              }}
                            >
                              <span style={{ display: "block", borderBottom: "1px solid #eaeeed", paddingBottom: "8px" }}>
                                Rename
                              </span>
                            </div>
                            <div style={{ paddingBottom: 0 }}
                              onClick={() => {
                                console.log("Duplicate", obj._id);
                              }}
                            >
                              <span style={{ display: "block", borderBottom: "1px solid #eaeeed", paddingBottom: "8px" }}>
                                Duplicate
                              </span>
                            </div>
                            <div
                              // className={libcss.danger}
                              onClick={() => {
                                deleteGroupingTemplate(obj._id);
                              }}
                            >
                              Delete
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </motion.div>
                )}
              </div>
            </div>
          </motion.div>
        </div>
        {createCustomTemplateModal && (
          <CustomTemplateModal
            defaultLibraryList={defaultLibraryList}
            setCreateCustomTemplateModal={setCreateCustomTemplateModal}
            createCustTemplate={createCustTemplate}
          />
        )}
      </div>
    </>
  );
};

export default StandaloneLibrary;
